export const PRODUCTS_LIMIT_STEP = 25;

export enum CategorySlug {
  Menu = "menu",
}
